import React, { useEffect, useState } from "react";
import { Table, message } from "antd";
import moment from "moment";
import { fetchCourtesies } from "../../apis/sessionsApi";
import useCourtesiesColumns from "./CommonColumns";

const CurrentAndFutureCourtesies = () => {
  const [upcomingCourtesies, setUpcomingCourtesies] = useState([]);
  const [loading, setLoading] = useState(false);
  const { columns, rowClassName } = useCourtesiesColumns();

  useEffect(() => {
    const fetchData = async () => {
      setLoading(true);
      try {
        const today = moment().format("YYYY-MM-DD");
        const upcomingCourtesiesResponse = await fetchCourtesies(today);
        setUpcomingCourtesies(upcomingCourtesiesResponse.data || []);
      } catch (err) {
        message.error("Error loading data");
      } finally {
        setLoading(false);
      }
    };
    fetchData();
  }, []);

  return (
    <>
      <h2>Cortesías Futuras o de Hoy</h2>
      <Table
        rowClassName={rowClassName}
        dataSource={upcomingCourtesies}
        columns={columns}
        rowKey="user_id"
        pagination={false}
        scroll={{ x: true }}
        className="text-center table-responsive"
        loading={loading}
      />
    </>
  );
};

export default CurrentAndFutureCourtesies;
